export const mockData = [
  {
    token: 'unique_director_token_1',
    active: true,
    first_name: 'Test',
    middle_name: 'A',
    last_name: 'approve',
    email: 'hd1@user.com',
    phone: '+15101111111',
    birth_date: '1991-01-01',
    title: 'Sr. Director',
    nationality: 'US',
    place_of_birth: 'US',
    last_modified_time: '2025-02-18T05:46:55Z',
    created_time: '2025-02-18T05:46:55Z',
  },
  {
    token: 'unique_director_token_2',
    active: true,
    first_name: 'Cool',
    middle_name: 'A',
    last_name: 'Dude',
    email: 'hd2@user.com',
    phone: '+15101111111',
    birth_date: '1992-01-01',
    title: 'Sr. Director',
    nationality: 'US',
    place_of_birth: 'US',
    last_modified_time: '2025-02-18T05:46:55Z',
    created_time: '2025-02-18T05:46:55Z',
  },
];
